import { createContext } from 'react';


export const UserContext = createContext<ProfileInformationType>({} as ProfileInformationType);
